import { Controller } from '@hotwired/stimulus'
import channel from '../channels/customer_supports_channel'

export default class extends Controller {
  changeStatus(){
    channel.changeStatus(this.element.closest('[data-csid]').dataset.csid)
  }
}
